import { ProductId } from 'src/replicant/iap';
import { PaymentResult, WebPaymentMethod } from '../iap.types';
import { paymentMethodHandlers } from './Config';
import { PaymentMethodHeader } from './PaymentMethodHeader';
import { PaymentMethodsList } from './PaymentMethodsList';

/**
 * Payment view content. Will prompt the user to select a payment method or show the payment method form.
 * @param args - The arguments for the payment view content.
 * @returns
 */
export function PaymentViewContent({
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  productId,
  close,
  onPurchaseStart,
  onAgeConfirm,
}: {
  selectedPaymentMethod: WebPaymentMethod | null;
  setSelectedPaymentMethod: (method: WebPaymentMethod) => void;
  productId: ProductId;
  close: (result: PaymentResult) => void;
  onPurchaseStart: () => void;
  onAgeConfirm: (accepted: boolean) => void;
}) {
  // Prompt the user to select a payment method if none is selected.
  if (!selectedPaymentMethod) {
    return (
      <PaymentMethodsList
        setSelectedPaymentMethod={setSelectedPaymentMethod}

        // TODO: Uncomment this line once the InfoView component is filled out with correct data.
        // @see: https://playcoinc.slack.com/archives/C04QADMV65B/p1712755577614069
        // onInfoClick={() => {
        //   setPage('info');
        // }}
      />
    );
  }
  // Render the payment method form.
  return (
    <>
      {paymentMethodHandlers[selectedPaymentMethod]({
        productId,
        close,
        onPurchaseStart,
        onAgeConfirm,
      })}
    </>
  );
}
